// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarNode_wrapper__csshf","deleteButton":"SidebarNode_deleteButton__TMWW6"};